import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { Trophy, ChevronRight, Sparkles } from "lucide-react";
import RankBadge from "./RankBadge";

export default function RankCard({ refreshKey }) {
    const [data, setData] = useState(null);
    useEffect(() => {
        api.get("/progress/rank").then(r => setData(r.data)).catch(() => setData(null));
    }, [refreshKey]);

    if (!data) {
        return (
            <div className="tactical-card p-6" data-testid="rank-card-skeleton">
                <div className="label-eyebrow text-accent-red">Rank</div>
                <div className="mt-2 text-sm text-muted-foreground">Loading…</div>
            </div>
        );
    }

    return (
        <div className="tactical-card relative overflow-hidden p-6" data-testid="rank-card">
            <div className="absolute -right-12 -top-12 h-40 w-40 rounded-full bg-accent-red/10 blur-2xl" />
            <div className="relative">
                <div className="flex items-center gap-3">
                    <RankBadge rankId={data.current?.id || 1} size="md" />
                    <div>
                        <div className="flex items-center gap-2">
                            <Trophy className="h-4 w-4 text-accent-red" />
                            <div className="label-eyebrow text-accent-red">Rank · {data.current.tier}</div>
                        </div>
                        <h3 className="mt-1 font-display text-2xl font-black uppercase leading-tight" data-testid="rank-current">{data.current.name}</h3>
                    </div>
                </div>
                <div className="mt-3 flex items-baseline gap-2">
                    <span className="font-display text-2xl font-black tabular-nums" data-testid="rank-exp">{data.total_exp.toLocaleString()}</span>
                    <span className="label-eyebrow text-muted-foreground">EXP</span>
                </div>

                {data.next ? (
                    <>
                        <div className="mt-5 flex items-center justify-between text-xs">
                            <span className="label-eyebrow text-muted-foreground">Next: {data.next.name}</span>
                            <span className="label-eyebrow text-accent-red">{data.to_next.toLocaleString()} to go</span>
                        </div>
                        <div className="mt-2 h-2 w-full bg-border">
                            <div className="h-full bg-accent-red transition-[width] duration-700" style={{ width: `${data.pct}%` }} data-testid="rank-progress-bar" />
                        </div>
                        <div className="mt-1 text-right text-xs text-muted-foreground">{data.pct}%</div>
                    </>
                ) : (
                    <div className="mt-5 flex items-center gap-2 text-accent-red">
                        <Sparkles className="h-4 w-4" />
                        <span className="text-xs font-bold uppercase tracking-widest">Maximum rank reached</span>
                    </div>
                )}

                <Link
                    to="/ranks"
                    data-testid="rank-card-view-all"
                    className="mt-5 inline-flex items-center gap-1 label-eyebrow text-muted-foreground hover:text-accent-red"
                >
                    View all 20 ranks <ChevronRight className="h-3 w-3" />
                </Link>
            </div>
        </div>
    );
}
